export const COMPANY = {
  name: "ASAP Fence & Gates",
  division: "Large Yard Division",
  phone: "(321) 486-6414",
  email: "vip@asapfencegates.com",
  address: "Seminole County, Florida",
  tagline: "Premium Fencing for Exceptional Properties",
  appointmentFee: 150,
};

export const HERO = {
  headline: "The Only Fence Contractor\nBuilt for Large Yards.",
  subheadline: "Dedicated. Premium. Yours.",
  description: "ASAP Fence & Gates' Large Yard Division exists for one reason — to give Seminole County homeowners with significant properties the dedicated attention, premium craftsmanship, and white-glove service their fence investment demands.",
  ctaPrimary: "Book Your VIP Fence Consultation — $150",
  ctaSecondary: "Call Us Directly",
  image: "/images/fences/white_vinyl.png",
};

export const YARD_SIZES = [
  {
    id: "large",
    label: "Large Yard",
    size: "¼ – ¾ Acre",
    budget: "$7,500 – $15,000",
    description: "Perfect for spacious Seminole County properties. Your dedicated project manager handles every detail.",
    recommended: true,
    message: "You're in the right place. Let's get started.",
  },
  {
    id: "estate",
    label: "Estate Property",
    size: "¾ Acre+",
    budget: "$15,000+",
    description: "Custom solutions for estate-level properties. Our most experienced crews and premium material selection.",
    recommended: true,
    message: "Our VIP team specializes in projects like yours.",
  },
];

export const DISQUALIFY_MESSAGE = {
  title: "This Division Is Exclusively for Large Properties",
  description: "Our Large Yard Division is reserved for Seminole County homeowners with ¼ acre or more. For properties under ¼ acre, our standard team provides excellent service — call (321) 486-6414 and we'll connect you.",
  note: "Not sure of your lot size? We can help — just call us.",
};

export const VALUE_PROPS = [
  {
    icon: "UserCheck",
    title: "Dedicated Project Manager",
    description: "One point of contact from estimate to final walkthrough. No runaround, no phone trees — just someone who knows your project inside and out.",
  },
  {
    icon: "Clock",
    title: "Same-Day & Next-Day Consultations",
    description: "VIP consultations are typically scheduled the same day or next business day. We come to your property, assess your needs, and discuss your vision — fast.",
  },
  {
    icon: "Shield",
    title: "Premium Materials Only",
    description: "We source commercial-grade materials that withstand Florida's sun, storms, and humidity. Every fence we build is engineered to last decades.",
  },
  {
    icon: "Award",
    title: "Licensed & Insured",
    description: "Fully licensed in Seminole County with comprehensive insurance. Your property and investment are protected at every stage.",
  },
];

export const FENCE_STYLES = [
  {
    title: "White Vinyl Privacy",
    shortDesc: "6ft modern rail, total privacy",
    description: "Six-foot white vinyl privacy fencing with sleek modern rails. The clean, contemporary look that Central Florida homeowners love — with zero painting or staining, ever.",
    image: "/images/fences/white_vinyl.png",
    features: ["6ft privacy height", "Modern rail design", "UV-resistant white finish", "Lifetime vinyl warranty"],
  },
  {
    title: "3-Rail Black Aluminum",
    shortDesc: "Flat top with rake bottom",
    description: "Elegant three-rail black aluminum fencing with flat top and rake bottom styling. Zero maintenance and built to withstand Florida's elements for decades.",
    image: "/images/fences/black_aluminum.png",
    features: ["Flat top & rake bottom", "Three-rail design", "Zero maintenance", "Lifetime warranty on finish"],
  },
  {
    title: "Cedar Fence",
    shortDesc: "Natural beauty with timeless warmth",
    description: "Premium cedar fencing brings natural elegance to your Central Florida property. Naturally resistant to insects and rot, cedar weathers beautifully in our subtropical climate.",
    image: "/images/fences/cedar.png",
    features: ["Natural insect resistance", "Beautiful grain patterns", "Weathers to silver-grey patina", "Custom height options"],
  },
  {
    title: "Pressure-Treated Pine",
    shortDesc: "Affordable durability for large yards",
    description: "Pressure-treated pine delivers solid fencing at an exceptional value. Treated to resist Florida's moisture and termites, it's the smart choice for large properties.",
    image: "/images/fences/pressure_treated_pine.png",
    features: ["Termite & rot treated", "Cost-effective for large runs", "Paintable & stainable", "Strong structural integrity"],
  },
  {
    title: "Black Vinyl Chain Link",
    shortDesc: "Coated for durability & security",
    description: "Black vinyl-coated chain link delivers serious security with a refined look. The vinyl coating protects against Florida's salt air and UV exposure. Available in all heights.",
    image: "/images/fences/chain_link.png",
    features: ["Available in all heights", "Black vinyl coating", "Corrosion resistant", "Commercial-grade mesh"],
  },
  {
    title: "DuraFence",
    shortDesc: "Next-gen composite fencing",
    description: "DuraFence composite panels combine the beauty of wood with the longevity of engineered materials. Won't warp, crack, or fade — even in Florida's demanding climate.",
    image: "/images/fences/durafence.png",
    features: ["Wood-look composite", "Won't warp or crack", "Fade-resistant finish", "25-year manufacturer warranty"],
  },
];

export const BEFORE_AFTER = {
  before: {
    image: "/images/fences/before_2.png",
    caption: "Before: Beautiful yard, but the fence has seen better days",
  },
  after: {
    image: "/images/fences/after_2.png",
    caption: "After: Same yard, stunning new white vinyl privacy fence",
  },
};

export const SATISFACTION_GUARANTEE = {
  headline: "100% Satisfaction Guarantee",
  description: "If you're not completely satisfied with your VIP consultation for any reason, we'll refund your $150 fee — no questions asked. We're that confident in the experience we deliver.",
};

export const FEATURED_IN = [
  { name: "Orlando Sentinel", type: "newspaper" },
  { name: "Seminole Chronicle", type: "newspaper" },
  { name: "WESH 2 News", type: "tv" },
  { name: "Central Florida Lifestyle", type: "magazine" },
  { name: "Sanford Herald", type: "newspaper" },
  { name: "Orlando Home & Garden", type: "magazine" },
];

export const PROCESS_STEPS = [
  {
    step: 1,
    title: "Book Your VIP Consultation",
    description: "Schedule online for $150 (credited toward your project). We'll be at your property the same day or next business day to assess your needs.",
    icon: "CalendarCheck",
  },
  {
    step: 2,
    title: "Receive Your Custom Proposal",
    description: "Within 48 hours, your dedicated project manager delivers a detailed proposal with material options, timeline, and transparent pricing.",
    icon: "MessageSquare",
  },
  {
    step: 3,
    title: "Professional Installation",
    description: "Our experienced crews arrive on schedule with premium materials. Your project manager keeps you updated every step of the way.",
    icon: "Wrench",
  },
  {
    step: 4,
    title: "Final Walkthrough & Warranty",
    description: "We walk every foot of your new fence together. You don't pay the final balance until you're completely satisfied.",
    icon: "CheckCircle2",
  },
];

export const TESTIMONIALS = [
  {
    name: "Robert & Linda M.",
    location: "Lake Mary, FL",
    rating: 5,
    text: "We have over half an acre and every other company made us feel like just another number. ASAP's Large Yard Division treated us like their only client. The fence is stunning and was done two days ahead of schedule.",
    project: "¾ Acre Cedar Privacy Fence",
  },
  {
    name: "David K.",
    location: "Sanford, FL",
    rating: 5,
    text: "Having a dedicated project manager made all the difference. I'm busy — I don't have time to chase down contractors. Marcus kept me informed the entire time. Best $12,000 I've spent on this house.",
    project: "Full Property Vinyl Replacement",
  },
  {
    name: "Jennifer & Tom S.",
    location: "Oviedo, FL",
    rating: 5,
    text: "The team surveyed our entire acre lot, handled all the permits, and installed a beautiful aluminum fence with custom gates. Professional from start to finish. This is how contracting should work.",
    project: "1 Acre Ornamental Aluminum",
  },
];

export const FAQ_ITEMS = [
  {
    question: "What makes the Large Yard Division different from your standard service?",
    answer: "Our Large Yard Division is a dedicated team that exclusively handles properties ¼ acre and above. You get a personal project manager, priority scheduling with same-day or next-day consultations, commercial-grade materials, and the focused attention that larger projects demand. We limit our active projects so your fence gets the care it deserves.",
  },
  {
    question: "Why is there a $150 consultation fee when other companies offer free estimates?",
    answer: "That's exactly the point. Free estimates are designed to get a salesperson on your property as quickly as possible — they rush through 15-minute walkthroughs, give you a cookie-cutter quote, and move on to the next lead. Our $150 VIP consultation is fundamentally different. You get 60-90 minutes with our most experienced project manager — not a junior estimator juggling 8 appointments that day. They bring physical material samples, review your HOA requirements, walk every inch of your fence line, discuss design options, and create a genuinely custom plan. The fee ensures we only meet with homeowners who are serious, which means we can take our time and focus entirely on helping you achieve your vision. And when you move forward, the entire $150 is credited toward your project — so it costs you nothing.",
  },
  {
    question: "Do you offer financing or pay-over-time options?",
    answer: "Yes! We partner with trusted financing providers so you can spread your fence investment over time. Most homeowners are approved quickly with competitive rates. Your project manager will walk you through available options during your consultation — there's no obligation to apply.",
  },
  {
    question: "How quickly can you start my project?",
    answer: "VIP consultations are typically same-day or next business day. After proposal approval, we typically begin installation within 2-3 weeks. For urgent projects, ask about our priority scheduling — we'll do everything we can to accommodate your timeline.",
  },
  {
    question: "Do you handle permits in Seminole County?",
    answer: "Absolutely. We handle 100% of the permitting process with Seminole County. Our team knows the local codes inside and out, so there are no surprises or delays. It's one less thing you have to think about.",
  },
  {
    question: "What kind of warranty do you offer?",
    answer: "Warranty varies by material: lifetime warranty on vinyl fencing, lifetime finish warranty on aluminum, 25-year manufacturer warranty on DuraFence composite, and 20-year warranty on vinyl-coated chain link. All projects include a 1-year workmanship guarantee on labor. Note: wood fencing (cedar and pressure-treated pine) is not covered by a material warranty due to the natural characteristics of wood, though our workmanship guarantee still applies.",
  },
  {
    question: "Can you work with my HOA requirements?",
    answer: "Yes — we work with HOAs throughout Seminole County daily. We'll review your community's guidelines before designing your fence to ensure full compliance, and we can provide architectural drawings if your HOA requires them for approval.",
  },
];

export const CONSULTATION_FORM_FIELDS = [
  { name: "fullName", label: "Full Name", type: "text", placeholder: "Your full name", required: true },
  { name: "email", label: "Email", type: "email", placeholder: "your@email.com", required: true },
  { name: "phone", label: "Phone", type: "tel", placeholder: "(407) 555-0000", required: false },
  { name: "address", label: "Property Address", type: "text", placeholder: "i.e., 123 Oak Lane, Sanford, FL 32771", required: true },
  { name: "yardSize", label: "Estimated Yard Size", type: "select", options: ["¼ – ½ Acre", "½ – ¾ Acre", "¾ – 1 Acre", "1+ Acre"], required: true },
  { name: "projectType", label: "Project Type", type: "select", options: ["New Fence Installation", "Fence Replacement", "Both — Replace & Extend"], required: true },
  { name: "fenceStyle", label: "Preferred Fence Style", type: "select", options: ["White Vinyl Privacy", "3-Rail Black Aluminum", "Cedar", "Pressure-Treated Pine", "Black Vinyl Chain Link", "DuraFence Composite", "Not sure — need guidance"], required: false },
  { name: "timeline", label: "Preferred Timeline", type: "select", options: ["As soon as possible", "Within 1 month", "Within 2-3 months", "Just exploring options"], required: false },
  { name: "message", label: "Tell Us About Your Project", type: "textarea", placeholder: "Any details about your property, preferences, or questions...", required: false },
];
